<template>
  <div :key="componentKey">
    <div v-for="player in players" :key="player.id">
      <h1 class="is-size-5" style="color: goldenrod;">
        <i class="fas fa-user"></i> &nbsp;
        <span v-if="player.edit != null && player.edit">
          <input class="input" v-model="player.player.name" style="width: 200px; display: inline;"/> 
          <span @click="savePlayerName(player)">
            &nbsp;<i class="fas fa-save"></i>
          </span>
        </span>
        <span v-else>
          <a @click="editPlayerName(player)" style="color: goldenrod;">
          <span class="player-name">{{ player.player.name }}</span>                        
          </a>
        </span>
      </h1>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'players'
  ],
  data () {
    return {
      componentKey: 0
    }
  },
  components : {

  },
  methods:{
    savePlayerName: function(player) {
      //alert("save player");
      this.$parent.savePlayerName(player);
      this.componentKey++;
    },
    editPlayerName: function(player) {
      //alert("edit player");
      this.$parent.editPlayerName(player);
      this.componentKey++;
    }
  }
}
</script>

<style lang="scss" scoped>

</style>